export const testIds = {
  menuItem: (depth: number) => `menuItemDepth${depth}`,
  positionBox: 'positionBox',
  scrollPageToTheLeft: 'scrollPageToTheLeft',
  scrollPageToTheRight: 'scrollPageToTheRight',
};
